export const NOTIFICATIONS_CONSTS = {
    GET_NOTIFICATION: 'GET_NOTIFICATION',
    GET_NOTIFICATION_COUNT: 'GET_NOTIFICATION_COUNT',
    UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
    SEE_ALL_NOTIFICATIONS: 'SEE_ALL_NOTIFICATIONS',
};
